import React, { useEffect, useRef, useState } from 'react';
import Lottie from 'lottie-react';
import "./CryptoCard.scss";

import card from '../../assets/animation/card.json';
import cardRes from "../../assets/animation/CardRes.json";
import useCurrentWidth from '../../Common/Hooks/useCurrentWidth';

function CryptoCard() {
	const width = useCurrentWidth();
	const divRef = useRef(null);
	const lottieRef = useRef(null);
	const [hasPlayed, setHasPlayed] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			const rect = divRef.current?.getBoundingClientRect();
			const isInView = rect && rect.top < window.innerHeight * 0.6 && rect.bottom > 0;
			const scrollY = window.scrollY;

			if (scrollY < 100 && hasPlayed) {
				setHasPlayed(false);
			}

			if (scrollY < 100) return;

			if (isInView && !hasPlayed) {
				lottieRef.current?.setSpeed(1);
				lottieRef.current?.play();
				setHasPlayed(true);
			}
		};

		window.addEventListener('scroll', handleScroll);
		return () => window.removeEventListener('scroll', handleScroll);
	}, [hasPlayed]);

	const animationData = width > 575 ? card : cardRes;

	return (
		<div className='cryptoCard' id='card'>
			<h4>UniWallet Pay Crypto card</h4>
			<h2>Crypto for Everyday Spending</h2>
			<p>
				Use your digital assets for routine expenses, with UWPS-backed Crypto Card!<br />
				Experience the flexibility and convenience of instant payments and withdrawals worldwide.
			</p>
			<div ref={divRef}>
				<Lottie
					lottieRef={lottieRef}
					animationData={animationData}
					loop={false}
					autoplay={false}
					className="aboutUs-lottie"
				/>
			</div>
		</div>
	);
}

export default CryptoCard;
